import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container, Image, Button } from 'react-bootstrap';

import Breadcrumbs from './../block/Breadcrumbs'
import TestimonialsSection from './../block/TestimonialsSection'
import FAQSection from './../block/FAQSection'

import styles from './../style/Esert.module.scss'

export default class Page extends Component {

  render() {

    const { data, ajax_data, user_profile_type } = this.props

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <section className={styles.section}>
          <Container className={styles.container}>
            <div className={styles.block}>
              <div className={styles.block_top}>
                <div>
                  Оплачивайте электронным сертификатом ТСР
                </div>
                <Image src={`/images/bezzatrat.png`} alt={`Сертификат`} width={244} height={50} />
              </div>
              <div className={styles.block_text}>
                Вы можете легко оплатить товары на нашем сайте с помощью электронного сертификата на технические средства реабилитации (ТСР), выданного Социальным фондом России. Это удобно, быстро и позволяет вам сразу приобрести те средства, которые вам действительно подходят.
              </div>
              <div className={styles.block_text}>
                На нашем сайте представлен код ТРУ, который подтверждает, что товар включён в список доступных для покупки по сертификату.
              </div>
              <div className={styles.block_block}>
                <div className={styles.block_block_top}>
                  <div className={styles.block_block_top_icon}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.5 5.83464V14.168C17.5 16.668 16.25 18.3346 13.3333 18.3346H6.66667C3.75 18.3346 2.5 16.668 2.5 14.168V5.83464C2.5 3.33464 3.75 1.66797 6.66667 1.66797H13.3333C16.25 1.66797 17.5 3.33464 17.5 5.83464Z" stroke="white" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12.9163 1.66797V8.21796C12.9163 8.58462 12.483 8.76795 12.2163 8.52629L10.283 6.74299C10.1247 6.59299 9.87465 6.59299 9.71632 6.74299L7.78303 8.52629C7.51636 8.76795 7.08301 8.58462 7.08301 8.21796V1.66797H12.9163Z" stroke="white" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M11.042 11.668H14.5837" stroke="white" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M7.5 15H14.5833" stroke="white" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <div className={styles.block_block_top_title}>Как получить сертификат?</div>
                  <div className={styles.block_block_top_text}>
                    Подайте заявление на получение сертификата <br />
                    через портал Госуслуги или лично в МФЦ
                  </div>
                </div>
                <div className={styles.block_block_top_content}>
                  <p>Для оформления электронного сертификата необходимы следующие документы:</p>
                  <ul>
                    <li>Паспорт РФ.</li>
                    <li>Номер действующей карты «Мир»</li>
                    <li>Подтверждённая учётная запись — если заявление подаётся на «Госуслугах».</li>
                    <li>Для людей с инвалидностью — действующая индивидуальная программа реабилитации или абилитации (ИПРА). ИПРА должна быть разработана в бюро медико-социальной экспертизы (МСЭ). Если сертификат оформляется на «Госуслугах», данные ИПРА обычно автоматически загружаются при заполнении заявления.</li>
                    <li>Для ветеранов — заключение о нуждаемости в обеспечении протезами или протезно-ортопедическими изделиями. Заключение должно быть выдано врачебной комиссией медорганизации, которая оказывает лечебно-профилактическую помощь ветеранам.</li>
                    <li>Для пострадавших на производстве из-за несчастного случая или профессионального заболевания — действующая программа реабилитации пострадавшего (ПРП).</li>
                  </ul>
                </div>
                <Image className={styles.block_block_image + ` d-none d-xl-block`} style={{ width: `auto` }} src={ajax_data?.bezzatrat} alt="Сертификаты" width="347" height="483" />
              </div>
              <div className={styles.block_botomblock}>
                <div>
                  <div className={styles.block_botomblock_title}>Команда StomaHelp всегда готова помочь вам</div>
                  <div>Мы поможем выбрать подходящий товар, проверим его соответствие требованиям и окажем поддержку в оформлении покупки.</div>
                </div>
                <Button href={`/katalog/`} className={styles.block_botomblock_btn} variant='light'>Перейти к покупкам</Button>
              </div>
            </div>
          </Container>
        </section>
        <TestimonialsSection
          page_data={data?.page_data || {}}
          feedback={ajax_data?.feedback_ng || []}
          feedback_legal={ajax_data?.feedback_ng_legal || []}
          user_profile_type={user_profile_type}
        />
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )
  }
}

Page.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  user_profile_type: PropTypes.string
}